<app-menu [stickyInput]="true"></app-menu>
<app-page-head [dataHeader]="pageHead"></app-page-head>
<app-documents-list></app-documents-list>
<app-sponsors></app-sponsors>
<app-footer></app-footer>
